import { Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import store from '@store/store.ts'
import ErrorBoundary from '@components/ErrorBoundary.tsx'
import SuspenseFallback from '@components/SuspenseFallback.tsx'

const View = lazy(() => import('@features/views/components/View.tsx'))

window.Timetoast.views = {
  ...window.Timetoast.views,
  show: {
    init: function ({ viewUuid, tableId }) {
      const root = createRoot(document.getElementById('react-target'))
      root.render(
        <ErrorBoundary withPadding={true}>
          <Provider store={store}>
            <Suspense fallback={<SuspenseFallback withPadding={true} />}>
              <View tableId={tableId} viewUuid={viewUuid} />
            </Suspense>
          </Provider>
        </ErrorBoundary>
      )
    },
  },
}
